/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Create_AccountInputs */



/**
* | output |
* | --- |
* | "Create Account" |
*
* @param {Auth_Verify_Create_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_create_account = /** @type {((inputs?: Auth_Verify_Create_AccountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Create_AccountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer le compte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear cuenta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Criar Conta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea Account")
	return /** @type {LocalizedString} */ ("Create Account")
});